function eventPointNative(event) {
  const svgNode = getSVGNodeFromTarget(event);
  if (svgNode == null) {
    return;
  }
  const screenCTM = svgNode.getScreenCTM();
  if (screenCTM == null) {
    return;
  }
  const point = svgNode.createSVGPoint();
  const {
    x,
    y
  } = getXYFromEventType(event);
  point.x = x;
  point.y = y;
  const transformedSVGPoint = point.matrixTransform(screenCTM.inverse());
  return {
    svgX: transformedSVGPoint.x,
    svgY: transformedSVGPoint.y
  };
  function getSVGNodeFromTarget(event) {
    if (event.currentTarget == null) {
      var _event$target;
      return (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.closest('svg');
    }
    return event.currentTarget;
  }
}
function getXYFromEventType(event) {
  return 'touches' in event ? {
    x: event.touches[0].pageX,
    y: event.touches[0].pageY
  } : {
    x: event.pageX,
    y: event.pageY
  };
}

export { eventPointNative, getXYFromEventType };
